<template>
  <section class="dash-section dash-section--chart" aria-labelledby="dash-analytics-heading">
    <div class="dash-section__head dash-section__head--wrap">
      <div>
        <h2 id="dash-analytics-heading" class="dash-section__title">Analytics</h2>
        <p class="dash-section__subtitle">{{ periodLabel }}</p>
      </div>

      <div class="dash-filters">
        <div class="dash-filters__periods" role="tablist" aria-label="Chart period">
          <button
            v-for="opt in periodOptions"
            :key="opt.key"
            type="button"
            class="dash-filter-pill"
            :class="{ 'dash-filter-pill--active': chartPeriod === opt.key }"
            role="tab"
            :aria-selected="chartPeriod === opt.key"
            @click="$emit('update:chartPeriod', opt.key)"
          >
            {{ opt.label }}
          </button>
        </div>

        <div class="dash-filters__metrics" role="tablist" aria-label="Chart metric">
          <button
            v-for="opt in metricOptions"
            :key="opt.key"
            type="button"
            class="dash-filter-pill dash-filter-pill--sm"
            :class="{ 'dash-filter-pill--active': chartMetric === opt.key }"
            role="tab"
            :aria-selected="chartMetric === opt.key"
            @click="$emit('update:chartMetric', opt.key)"
          >
            {{ opt.label }}
          </button>
        </div>
      </div>
    </div>

    <DashboardChart :points="points" :loading="loading" />
  </section>
</template>

<script setup>
import DashboardChart from '@/components/Dashboard/DashboardChart.vue'

defineOptions({ name: 'DashboardAnalyticsSection' })

defineProps({
  points: { type: Array, default: () => [] },
  chartPeriod: { type: String, default: '30d' },
  chartMetric: { type: String, default: 'calls' },
  periodLabel: { type: String, default: '' },
  loading: { type: Boolean, default: false },
})

defineEmits(['update:chartPeriod', 'update:chartMetric'])

const periodOptions = [
  { key: 'today', label: 'Today' },
  { key: '7d', label: '7 Days' },
  { key: '30d', label: '30 Days' },
]

const metricOptions = [
  { key: 'calls', label: 'Calls' },
  { key: 'duration', label: 'Duration' },
  { key: 'cost', label: 'Cost' },
  { key: 'credits', label: 'Credits' },
]
</script>
